/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Geliver_NedirInputs */

const tr_faq_q_geliver_nedir = /** @type {(inputs: Faq_Q_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliver nedir, ne işe yarar?`)
};

const en_faq_q_geliver_nedir = /** @type {(inputs: Faq_Q_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Geliver?`)
};

const de_faq_q_geliver_nedir = /** @type {(inputs: Faq_Q_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Geliver?`)
};

const ru_faq_q_geliver_nedir = /** @type {(inputs: Faq_Q_Geliver_NedirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что такое Geliver?`)
};

/**
* | output |
* | --- |
* | "What is Geliver?" |
*
* @param {Faq_Q_Geliver_NedirInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_geliver_nedir = /** @type {((inputs?: Faq_Q_Geliver_NedirInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Geliver_NedirInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_geliver_nedir(inputs)
	if (locale === "de") return de_faq_q_geliver_nedir(inputs)
	if (locale === "ru") return ru_faq_q_geliver_nedir(inputs)
	return tr_faq_q_geliver_nedir(inputs)
});